import { httpGet, httpPut, httpDelete, httpPost } from '../../../util/request.js';
import appConfig from '../../../config';

export default class Auth {

	static LOGIN_API_URL = appConfig.gatewayUrl + appConfig.authServicePath + "/auth/login";
	static GET_SESSION_API_URL = appConfig.gatewayUrl + appConfig.authServicePath + "/auth/session";
	static CHANGE_PWD_API_URL = appConfig.gatewayUrl + appConfig.authServicePath + "/auth/updatePwd";
	static OA_LOGIN_API_URL = appConfig.gatewayUrl + appConfig.authServicePath + "/auth/oa-link-login";
	static SM_PROVIDER_LOGIN_API_URL = appConfig.gatewayUrl + appConfig.authServicePath + "/auth/sm-provider-link-login";
	static OA_WARN_LOGIN_API_URL = appConfig.gatewayUrl + appConfig.authServicePath + "/auth/oa-warn-link-login";

	static login(username, password) {
		let params = { username: username, password: password, appCode: appConfig.appCode, scope: appConfig.scope, grantType: appConfig.grantType };
		return httpPost(Auth.LOGIN_API_URL, params);
	}

	static getSession() {
		let params = {};
		return httpGet(Auth.GET_SESSION_API_URL, params);
    }
    
    static changePwd(oldPwd,newPwd) {
		let params = {oldPwd:oldPwd,newPwd:newPwd};
		return httpPost(Auth.CHANGE_PWD_API_URL, params);
    }

	static oaLinkLogin(tokenId) {
		let params = {
			appId:appConfig.appCode,
			scope:appConfig.scope,
			grantType:appConfig.grantType,
			oaTokenId:tokenId
		};
		return httpPost(Auth.OA_LOGIN_API_URL, params)
	}
    
	static smProviderLinkLogin(ticket) {
		let params = {ticket:ticket};
		return httpPost(Auth.SM_PROVIDER_LOGIN_API_URL, params)
	}

	static oaWarnLinkLogin(mobile){
		let params = {
			appId:appConfig.appCode,
			scope:appConfig.scope,
			grantType:appConfig.grantType,
			mobile:mobile
		};
		return httpPost(Auth.OA_WARN_LOGIN_API_URL, params)
	}
}